import React from "react";
import priceCalculations from "../../../functions/priceCalculations";
import { IncludedModifierTagButton } from "./IncludedModifierTagButton";
export var IncludedModifierSection = function (_a) {
    var includedModifierIds = _a.includedModifierIds, modifiers = _a.modifiers, selectedMainItem = _a.selectedMainItem, includedChoices = _a.includedChoices, excludedModifierIds = _a.excludedModifierIds, onExclude = _a.onExclude, onReAdd = _a.onReAdd, onSetFirstHalf = _a.onSetFirstHalf, onSetSecondHalf = _a.onSetSecondHalf, onSetWhole = _a.onSetWhole, onSetExtra = _a.onSetExtra, onSetNormal = _a.onSetNormal;
    if (includedModifierIds.length === 0) {
        return null;
    }
    var shouldShowExtraOption = function (modifier) {
        var _a, _b;
        if (!modifier.showDouble) {
            return false;
        }
        if (((_b = (_a = window.session) === null || _a === void 0 ? void 0 : _a.store) === null || _b === void 0 ? void 0 : _b.show_extra_option_without_charge) === true) {
            return true;
        }
        if (!selectedMainItem) {
            return true;
        }
        var addedModifierPrice = Number(priceCalculations.calculateModifierPriceForGivenItem(selectedMainItem, modifier));
        return addedModifierPrice > 0;
    };
    return (React.createElement("section", { className: "item-customization-section" },
        React.createElement("h3", { className: "item-customization-section-title" }, "Included toppings"),
        React.createElement("div", { className: "item-customization-modifier-list" }, includedModifierIds.map(function (modifierId) {
            var excluded = excludedModifierIds.includes(modifierId);
            var choice = includedChoices[modifierId] || { quantity: 1, portion: "whole", size: "normal" };
            var modifier = modifiers[modifierId] || { name: modifierId };
            return (React.createElement(IncludedModifierTagButton, { key: modifierId, modifierId: modifierId, label: modifier.name, choice: choice, excluded: excluded, showHalf: Boolean(modifier.showHalf), showDouble: shouldShowExtraOption(modifier), onExclude: onExclude, onReAdd: onReAdd, onSetFirstHalf: onSetFirstHalf, onSetSecondHalf: onSetSecondHalf, onSetWhole: onSetWhole, onSetExtra: onSetExtra, onSetNormal: onSetNormal }));
        }))));
};
